<template>
	<form @submit.prevent="handleSubmit">
		<label class="omapi-integrations-form__field-wrap">
			<div class="omapi-integrations-form__field-wrap-label large">
				<span>{{ $get('fields.notifications.label', 'Default notification settings for Monster Leads') }}</span>
			</div>
			<div class="omapi-integrations-form__field-wrap-field">
				<select v-model="notifications" name="notifications" class="omapi-input omapi-input__select">
					<option v-for="(label, value) in options" :key="value" :value="value">
						{{ label }}
					</option>
				</select>
			</div>
		</label>
		<common-transition-slide :active="showEmailField" @opened="resize" @closed="resize">
			<integrations-form-field
				:field="fields.email_addresses"
				:largeLabel="true"
				placeholder="Comma-separated Email Addresses"
				v-model="email_addresses"
			/>
		</common-transition-slide>
		<label class="omapi-integrations-form__field-wrap">
			<div class="omapi-integrations-form__field-wrap-label large">
				<span>{{ $get('fields.store_ips.label', 'Store IP Addresses? (Turn off for GDPR)') }}</span>
			</div>
			<div class="omapi-integrations-form__field-wrap-field">
				<common-toggle-input
					class="omapi-input"
					wrapTag="span"
					onText="Yes"
					offText="No"
					name="store_ips"
					v-model="store_ips"
				/>
			</div>
		</label>
	</form>
</template>
<script>
import get from 'lodash/get'
import { bulkWatchHandler } from '@/components/utils'
import { altform } from '@/integrations/mixins/altform'

export default {
	mixins : [ altform ],
	props  : {
		/**
		 * Provider
		 */
		provider : {
			type : Object,
		},
	},
	data () {
		const providerData  = this.$get('provider.integrations.0.providerData')
		return {
			fields  : this.getFields(),
			options : {
				none   : 'No Notifications',
				every  : 'Every New Lead',
				daily  : 'Daily Digest',
				weekly : 'Weekly Digest',
			},
			notifications   : get(providerData, 'notifications', 'none'),
			store_ips       : !!get(providerData, 'store_ips', false),
			email_addresses : get(providerData, 'email_addresses', ''),
		}
	},
	watch : {
		...bulkWatchHandler([ 'notifications', 'store_ips', 'email_addresses' ], 'update'),
		showEmailField (show) {
			if (show && !this.email_addresses) {
				this.email_addresses = this.$store.getters.userEmail
			}
		},
	},
	computed : {
		/**
		 * Show Email Field
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Shoud the email field be shown?
		 */
		showEmailField () {
			return '' !== this.notifications && 'none' !== this.notifications
		},
	},
	methods : {
		getFieldData () {
			return {
				notifications   : this.notifications,
				store_ips       : this.store_ips || 0,
				email_addresses : this.email_addresses,
			}
		},
	},
}
</script>
